import { motion } from 'framer-motion'
import SectionWrapper from '../layout/SectionWrapper'
import { talents } from '../../data/stats'

export default function CelebrationSection() {
  return (
    <SectionWrapper
      id="celebration"
      gradient="from-dark-primary via-primary-pink/5 to-dark-primary"
    >
      {/* Header */}
      <motion.div className="text-center mb-16">
        <motion.span
          className="tag-pill mb-4"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <span>🌟</span>
          <span>Célébration</span>
        </motion.span>

        <motion.h2
          className="text-4xl md:text-6xl font-serif font-bold gradient-text mb-4"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
        >
          Tes Accomplissements
        </motion.h2>
      </motion.div>

      {/* Academic Achievement */}
      <motion.div
        className="max-w-3xl mx-auto mb-16"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
      >
        <div className="glass-card pink-glow text-center py-8">
          <motion.span
            className="text-7xl block mb-6"
            animate={{ rotate: [0, 10, -10, 0], scale: [1, 1.1, 1] }}
            transition={{ duration: 2, repeat: Infinity }}
          >
            🎓
          </motion.span>

          <h3 className="text-3xl font-serif font-bold text-white mb-4">
            Félicitations pour Ton Bac & Ta Maîtrise
          </h3>

          <p className="text-light-pink-100/80 max-w-xl mx-auto mb-6">
            Quel chemin parcouru ! Je suis incroyablement fier de tout ce que tu as accompli.
            Chaque effort, chaque heure d'étude, a porté ses fruits.
            Ta persévérance est une source d'inspiration.
          </p>

          <motion.div
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-pink/20 rounded-full"
            whileHover={{ scale: 1.05 }}
          >
            <span className="text-2xl">✨</span>
            <span className="font-bold text-primary-pink">Une nouvelle aventure commence !</span>
            <span className="text-2xl">✨</span>
          </motion.div>
        </div>
      </motion.div>

      {/* Talents */}
      <motion.div
        className="mb-16"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
      >
        <h3 className="text-2xl font-serif font-bold text-center text-white mb-8">
          🎨 Tes Passions & Talents
        </h3>

        <div className="grid md:grid-cols-3 gap-6 max-w-4xl mx-auto">
          {talents.map((talent, index) => (
            <motion.div
              key={talent.id}
              className="glass-card text-center"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.15 }}
              whileHover={{ y: -5, scale: 1.02 }}
            >
              <motion.span
                className="text-5xl block mb-4"
                whileHover={{ rotate: 360 }}
                transition={{ duration: 0.5 }}
              >
                {talent.emoji}
              </motion.span>
              <h4 className="text-xl font-bold text-white mb-2">{talent.title}</h4>
              <p className="text-light-pink-100/70 text-sm">{talent.description}</p>
            </motion.div>
          ))}
        </div>
      </motion.div>

      {/* Love Messages */}
      <motion.div
        className="max-w-4xl mx-auto"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
      >
        <h3 className="text-2xl font-serif font-bold text-center text-white mb-8">
          💬 Les Messages Qui M'ont Fait Tomber Amoureux
        </h3>

        <div className="glass-card">
          <p className="text-light-pink-100/80 text-center leading-relaxed">
            Ces messages ne sont pas de simples mots sur un écran.
            Ils sont la preuve de ton amour, de ta tendresse, de ta présence même à distance.
            Chaque message m'a rapproché de toi, et chaque conversation m'a convaincu
            que tu es celle avec qui je veux passer le reste de mes jours.
          </p>

          <motion.div
            className="mt-8 text-center"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.5 }}
          >
            <p className="text-lg text-white font-medium">
              Tu m'as montré que l'amour véritable se construit dans:
            </p>
            <div className="flex flex-wrap justify-center gap-4 mt-4">
              {['Les petits gestes', 'Les mots doux', 'La constance'].map((item, i) => (
                <motion.span
                  key={i}
                  className="px-4 py-2 bg-primary-pink/20 rounded-full text-primary-pink"
                  initial={{ opacity: 0, scale: 0.8 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ delay: 0.7 + i * 0.1 }}
                >
                  {item}
                </motion.span>
              ))}
            </div>
          </motion.div>
        </div>
      </motion.div>

      {/* Quote */}
      <motion.blockquote
        className="text-center mt-16 max-w-2xl mx-auto"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
      >
        <p className="text-xl md:text-2xl text-light-pink-100/80 italic font-serif leading-relaxed">
          "Plus qu'une partenaire, t'es ma meilleure amie
          <br />
          Celle avec qui je veux passer ma vie"
        </p>
        <footer className="mt-4 text-primary-pink text-sm">
          — Verse 5
        </footer>
      </motion.blockquote>
    </SectionWrapper>
  )
}
